import { palette } from "../../Theme";
// Theme configuration:
export const MuiButton = {
    styleOverrides: {
        root: {
            minWidth: 0,
            fontWeight: 600,
            letterSpacing: "0.46px",
            // 2024-09-11. We decided (back in April, probably) to change the text-transform from the old "capitalize" value to "none", since
            //              the prevailing preference among UX and copywriters in SundaySky is that only the first letter of the entire button text
            //              should be capitalized, rather than the first letter of EVERY word.
            textTransform: "none"
        },
        startIcon: {
            marginRight: "8px",
            marginLeft: 0,
            justifyContent: "center",
            alignItems: "center"
        },
        endIcon: {
            marginLeft: "8px",
            marginRight: 0,
            justifyContent: "center",
            alignItems: "center"
        },
        sizeSmall: {
            fontSize: "13px",
            lineHeight: "22px",
            padding: "1px 8px",
            borderRadius: "12px"
        },
        outlinedSizeSmall: {
            padding: "0 7px"
        },
        iconSizeSmall: {
            "&>*:nth-of-type(1)": {
                fontSize: "13px"
            }
        },
        sizeMedium: {
            fontSize: "13px",
            lineHeight: "22px",
            padding: "5px 15px",
            borderRadius: "16px"
        },
        outlinedSizeMedium: {
            padding: "4px 14px"
        },
        iconSizeMedium: {
            "&>*:nth-of-type(1)": {
                fontSize: "13px"
            }
        },
        sizeLarge: {
            fontSize: "14px",
            lineHeight: "24px",
            padding: "6px 16px",
            borderRadius: "18px"
        },
        outlinedSizeLarge: {
            padding: "5px 15px"
        },
        iconSizeLarge: {
            "&>*:nth-of-type(1)": {
                fontSize: "14px"
            }
        },
        containedGradient: {
            "&:not(.Mui-disabled):not(:hover)": {
                backgroundImage: `linear-gradient(135deg, ${palette.brand.gradientMagentaBlue})`
            }
        },
        containedWhite: ({ theme }) => ({
            color: theme.palette.primary.main
        })
    },
    defaultProps: {
        size: "large"
    }
};
//# sourceMappingURL=Button.js.map